import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import { initPostHog } from "@/lib/posthog";
import { PrivacyPage } from "./pages/PrivacyPage";

const rootElement: HTMLElement = document.getElementById("root") as HTMLElement;
const isPostHogEnabled: boolean = initPostHog();
const rootApp: React.JSX.Element = isPostHogEnabled ? (
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <PrivacyPage />
    </PostHogErrorBoundary>
  </PostHogProvider>
) : (
  <PrivacyPage />
);

createRoot(rootElement).render(rootApp);
